module.exports = __webpack_public_path__ + "static/media/silvan.55dc7835.jpg";